import React, { useState } from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import GlowingButton from 'components/base/GlowingButton';
import ArrowedText from './ArrowedText';

const GrayedCover = styled.div`
  background-color: ${getColor('silverSand')};
  opacity: ${({ hide }) => (hide ? 0 : 0.5)};
  position: absolute;
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  z-index: 10;
  transition: opacity 500ms;
`;
const AbsoluteGlowingButton = styled(GlowingButton)`
  position: absolute;
  z-index: 100;
  ${({ disabled }) => (disabled ? 'pointer-events: none;' : '')}
}`;

const AbsoluteArrowedText = styled(ArrowedText)`
  position: absolute;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  z-index: 100;
  transition: opacity 500ms;
`;

const Section = ({
  buttonPosition,
  onButtonClick,
  coverProps,
  isActive = false,
  textProps,
  clearSelection,
  initialMode,
  isDummy = false,
  arrowLength
}) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <>
      {!isDummy && (
        <AbsoluteGlowingButton
          isGlowing
          onClick={onButtonClick}
          color={isHover ? 'dodgerBlue' : 'chambray'}
          onMouseOver={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
          style={buttonPosition}
          disabled={isActive}
        />
      )}
      <GrayedCover
        onMouseLeave={() => isActive && clearSelection()}
        hide={initialMode || isActive}
        height={coverProps.height}
        width={coverProps.width}
        style={coverProps.position}
      />
      {!isDummy && (
        <AbsoluteArrowedText
          isActive={isActive}
          isArrowLeft={!textProps.isLeft}
          text={textProps.text}
          style={textProps.position}
          arrowLength={arrowLength}
        />
      )}
    </>
  );
};
export default Section;
